import { ColumnMapType, TableConfigurationType, TablesPanel } from "./Table-settings"

export const keyUserLocalStorage = 'LZpGHL{Er7'
const keyDecrypt = 'KEY_DECRYPT_ARBOLINK'

export const getLoggedUser = () => {
		const user = localStorage.getItem(keyUserLocalStorage)
		if (!user) return null

		const isFromPuppeteer = localStorage.getItem('puppeteer') != null
		if (isFromPuppeteer) {
			return JSON.parse(user)
		}

		return JSON.parse(decrypt(user))
	}

export const setLoggedUser = (user): void => {
		localStorage.setItem(keyUserLocalStorage, encrypt(JSON.stringify(user)))
	}

export const getIdentifierName = (): string => {
	const identifier = localStorage.getItem('identifier')
	return identifier != null ? identifier : 'Identificador'
}

export const encrypt = (message: string) => {
		let result = ''
		for (let i = 0; i < message.length; i++) {
			const charCode = message.charCodeAt(i) ^ keyDecrypt.charCodeAt(i % keyDecrypt.length)
			result += String.fromCharCode(charCode)
		}
		return result
	}

export const decrypt = (message: string) => {
		let result = ''
		for (let i = 0; i < message.length; i++) {
			const charCode = message.charCodeAt(i) ^ keyDecrypt.charCodeAt(i % keyDecrypt.length)
			result += String.fromCharCode(charCode)
		}
		return result

	}

export const setLastValuesForSchedulePlanting = (height: number, fuste: number, cupProjection: number, dap: number) => {
	const lastValuesForSchedulePlanting = {
		lastHeight: height,
		lastFuste: fuste,
		lastCupProjection: cupProjection,
		lastDap: dap
	}

	localStorage.setItem('lastValuesForSchedulePlanting', JSON.stringify(lastValuesForSchedulePlanting))
}

export const getLastValuesForSchedulePlanting = (propety: string): number => {
	const lastValuesForSchedulePlanting = localStorage.getItem('lastValuesForSchedulePlanting')

	if (lastValuesForSchedulePlanting) {

		const lastValuesObj = JSON.parse(lastValuesForSchedulePlanting)

		return lastValuesObj[propety]

	} else {

		return 0

	}
}

export const removeLastValuesForSchedulePlanting = () => {
	localStorage.remove('lastValuesForSchedulePlanting')
}

export const setLastFormatCup = (formatCup: string, pathSvg: string) => {
	const lastFormatCup = {
		formatCup,
		pathSvg
	}
	localStorage.setItem('lastFormatCup', JSON.stringify(lastFormatCup))
}

export const getLastFormatCup = (): string => {
	const lastFormatCup = localStorage.getItem('lastFormatCup')
	return lastFormatCup
}

export const removeLastFormatCup = () => {
	localStorage.removeItem('lastFormatCup')
}

export const setViewOnlyPinsSelected = (viewOnlyPinsSelected: boolean) => {
	const viewOnlyPinsSelectedString = String(viewOnlyPinsSelected)

	localStorage.setItem('viewOnlyPinsSelected', encrypt(viewOnlyPinsSelectedString))
}

export const getViewOnlyPinsSelected = (): boolean => {
	const getViewOnlyPinsSelected = localStorage.getItem('viewOnlyPinsSelected')

	if (!getViewOnlyPinsSelected) {
		return false
	} else {
		return JSON.parse(decrypt(getViewOnlyPinsSelected))
	}
}

export const setEnableLegalFundamentation = (enableLegalFundamentation: boolean) => {
	const enableLegalFundamentationString = String(enableLegalFundamentation)

	localStorage.setItem('enableLegalFundamentation', encrypt(enableLegalFundamentationString))
}

export const getEnableLegalFundamentation = (): boolean => {
	const getEnableLegalFundamentation = localStorage.getItem('enableLegalFundamentation')

	if (!getEnableLegalFundamentation) {
		return false
	} else {
		return JSON.parse(decrypt(getEnableLegalFundamentation))
	}
}

export const setEnableCommunication = (enableCommunication: boolean) => {
	const enableCommunicationString = String(enableCommunication)

	localStorage.setItem('enableCommunication', encrypt(enableCommunicationString))
}

export const getEnableCommunication = (): boolean => {
	const getEnableCommunication = localStorage.getItem('enableCommunication')

	if (!getEnableCommunication) {
		return false
	} else {
		return JSON.parse(decrypt(getEnableCommunication))
	}
}

export const getZendeskToken = (): string | null => {
	const zendeskToken = localStorage.getItem('zendesk_token')

	if (zendeskToken) {
		return JSON.parse(zendeskToken)
	} else {
		return null
	}
}

export const setLengthTable = (lengthTable: string) => {
	localStorage.setItem('lengthTable', lengthTable)
}

export const getLengthTable = (): string => {
	const lengthTable: string = localStorage.getItem('lengthTable')

	if (lengthTable) {
		return lengthTable
	} else {
		return '10'
	}
}

export const setEnableCloneInventory = (enableCloneInventory: boolean) => {
	const enableCloneInventoryString = String(enableCloneInventory)

	localStorage.setItem('enableCloneInventory', encrypt(enableCloneInventoryString))
}

export const getEnableCloneInventory = (): boolean => {
	const enableCloneInventory = localStorage.getItem('enableCloneInventory')

	if (!enableCloneInventory) {
		return false
	} else {
		return JSON.parse(decrypt(enableCloneInventory))
	}
}

export const setHasMultipleCompanyProviders = (hasMultipleCompanyProviders: boolean) => {
	const hasMultipleCompanyProvidersString = String(hasMultipleCompanyProviders)

	localStorage.setItem('hasMultipleCompanyProviders', encrypt(hasMultipleCompanyProvidersString))
}

export const getHasMultipleCompanyProviders = (): boolean => {
	const hasMultipleCompanyProviders = localStorage.getItem('hasMultipleCompanyProviders')

	if (!hasMultipleCompanyProviders) {
		return false
	} else {
		return JSON.parse(decrypt(hasMultipleCompanyProviders))
	}
}

export const removeHasMultipleCompanyProviders = () => {
	localStorage.removeItem('hasMultipleCompanyProviders')
}

export const setTablesConfig = (settings: TableConfigurationType) => {
	localStorage.setItem('tablesConfig', JSON.stringify(settings));
}

export const getTablesConfig = (): TableConfigurationType | null => {
  const config = localStorage.getItem('tablesConfig');

  if (config) {
    return JSON.parse(config) as TableConfigurationType;
  } else {
		return null;
	}
}

export const updateTableConfig = (
	tableName: TablesPanel,
  settings: ColumnMapType
) => {

	const configs = getTablesConfig();

	if (configs) {
		configs[tableName].columns = settings;

		setTablesConfig(configs);
	}
}

export const clearTablesConfig = () => {
	localStorage.removeItem('tablesConfig');
}

export const setOperationsServiceForReport = (
	operationsService: Array<{
		idMongo: string,
		fragmentId?: number
	}>
) => {
	localStorage.setItem('operationsDataToReport', JSON.stringify(operationsService));
}

export const setSessionStorageOperationsServiceForReport = (
	operationsService: Array<{
		idMongo: string,
		fragmentId?: number
	}>
) => {
	sessionStorage.setItem('operationsDataToReport', JSON.stringify(operationsService));
}

export const getOperationsServiceForReport = (): Array<{
	idMongo: string,
	fragmentId?: number
}> => {
	const operationsServiceForReport = localStorage.getItem('operationsDataToReport');

  if (operationsServiceForReport) {
    return JSON.parse(operationsServiceForReport) as Array<{ idMongo: string, fragmentId?: number}>;
  } else {
		return [];
	}
}

export const getSessionOperationsServiceForReport = (): Array<{
	idMongo: string,
	fragmentId?: number
}> | null => {
	const operationsServiceForReport = sessionStorage.getItem('operationsDataToReport');

  if (operationsServiceForReport) {
    return JSON.parse(operationsServiceForReport) as Array<{ idMongo: string, fragmentId?: number}>;
  } else {
		return null ;
	}
}

export const removeOperationServiceForReport = () => {
	localStorage.removeItem('operationsDataToReport');
}